import './home.scss'
import React, { useState, useRef, useEffect } from 'react'
import ModalBS from '../../components/modal/modal'
import Navbar from '../../components/navbar/navbar'
import BreadcrumbSample from '../../components/breadcrumb/breadcrumb'
import api_host from '../../env'
import UpdatePassword from './updatePassword'
import CurrentMail from './currentMail'
import MessageHistory from './messageHistory'

const DetailView = ({
  history,
  searchedAccountID,
  searchedAccountEmails,
  searchedAccountStatus,
  setSearchedAccountEmails,
  setView
}) => {
  const [mailToDelete, setMailToDelete] = useState('')
  const [showDeleletEmailModal, setShowDeleletEmailModal] = useState(false)
  const handleAddEmailInput = ({ currentTarget }) =>
    setAddEmailInput(currentTarget.value.trim())
  const [detailViewType, setDetailViewType] = useState('account')
  const [addEmailError, setAddEmailError] = useState(null)
  const [deleteEmailError, setDeleteEmailError] = useState(null)
  const [addEmailInput, setAddEmailInput] = useState('')
  const handleDelModalClose = () => setShowDeleletEmailModal(false)
  const [unlockUserError, setUnlockUserError] = useState(null)
  const [accountStatusError, setAccountStatusError] = useState(null)
  const [isChecked, setIsChecked] = useState(searchedAccountStatus)

  const addEmailRef = useRef(null)
  
  useEffect(() => {
    console.log("(useEffect) searchedAccountStatus = " + searchedAccountStatus)
    console.log("(useEffect) isChecked = " + isChecked)
    //setIsChecked(searchedAccountStatus)
    setAccountStatusInAPI()

  }, [isChecked])
  
  const handleDeleteEmail = emailToBeDeleted => {
    if (!sessionStorage.getItem('token')) {
      setDeleteEmailError('User not logged in')
      return
    }
    const config = {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        token: sessionStorage.getItem('token')
      },
      body: JSON.stringify({
        email: emailToBeDeleted
      })
    }
    //Delete email
    fetch(`${api_host}/accounts/${searchedAccountID}/emails`, config)
      .then(res => res.json())
      .then(data => {
        if (data && ((data.message && data.message.indexOf('Failed - Invalid Token') > -1) || (data.error && data.error.indexOf('Failed - Invalid SessionGUID') > -1))) {
          sessionStorage.removeItem('token')
          history.push('/signin')
        } else if (data && data.error && Array.isArray(data.error)) {
          setDeleteEmailError(data.error.join('\n'))
        } else if (data && data.error && !Array.isArray(data.error)) {
          setDeleteEmailError(data.error)
        } else if (data && data.description) {
          setDeleteEmailError(null)
          setAddEmailError(null)
          setUnlockUserError(null)
          let tempEmailList = [...searchedAccountEmails]
          tempEmailList = tempEmailList.filter(e => e != emailToBeDeleted)
          setSearchedAccountEmails(tempEmailList)
          setAccountStatusError(null)
        } else {
          setDeleteEmailError('Something went wrong')
        }
      })
      .catch(() => setDeleteEmailError('Something went wrong'))
  }

  const handleAddEmail = () => {
    if (!sessionStorage.getItem('token')) {
      setAddEmailError('User not logged in')
      return
    }
    if (!addEmailInput) {
      setAddEmailError('Email field is empty')
      return
    }
    const config = {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        token: sessionStorage.getItem('token')
      },
      body: JSON.stringify({
        email: addEmailInput
      })
    }
    // Add email API call
    fetch(`${api_host}/accounts/${searchedAccountID}/emails`, config)
      .then(res => res.json())
      .then(data => {
        if (data && ((data.message && data.message.indexOf('Failed - Invalid Token') > -1) || (data.error && data.error.indexOf('Failed - Invalid SessionGUID') > -1))) {
          sessionStorage.removeItem('token')
          history.push('/signin')
        } else if (data && data.error && Array.isArray(data.error)) {
          setAddEmailError(data.error.join('\n'))
        } else if (data && data.error && !Array.isArray(data.error)) {
          setAddEmailError(data.error)
        } else if (data && data.description) {
          setAddEmailError(null)
          setDeleteEmailError(null)
          setAddEmailInput('')
          setUnlockUserError(null)
          if (addEmailRef && addEmailRef.current && addEmailRef.current.value) {
            addEmailRef.current.value = ''
          }
          const tempEmailList = [...searchedAccountEmails]
          tempEmailList.push(addEmailInput)
          setSearchedAccountEmails(tempEmailList)
          setAccountStatusError(null)
        } else {
          setAddEmailError('Something went wrong')
        }
      })
      .catch(() => setAddEmailError('Something went wrong'))
  }

  const handleUnlockUser = () => {
    if (!sessionStorage.getItem('token')) {
      setUnlockUserError('User not logged in')
      return
    }
    const config = {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        token: sessionStorage.getItem('token')
      }
    }
    // Unlock user API call
    fetch(`${api_host}/accounts/${searchedAccountID}/unlock`, config)
      .then(res => res.json())
      .then(data => {
        if (data && ((data.message && data.message.indexOf('Failed - Invalid Token') > -1) || (data.error && data.error.indexOf('Failed - Invalid SessionGUID') > -1))) {
          sessionStorage.removeItem('token')
          history.push('/signin')
        } else if (data && data.error && Array.isArray(data.error)) {
          setUnlockUserError(data.error.join('\n'))
        } else if (data && data.error && !Array.isArray(data.error)) {
          setUnlockUserError(data.error)
        } else if (data && data.description) {
          setAddEmailError(null)
          setDeleteEmailError(null)
          setUnlockUserError("User Unlocked Successfully")
          setAccountStatusError(null)
          //Success

        } else {
          setUnlockUserError('Something went wrong')
        }
      })
      .catch(() => setUnlockUserError('Something went wrong'))
  }

  //change account status
  const handleAccountStatus = () => {
    //setsearchedAccountStatus(!searchedAccountStatus)
    //searchedAccountStatus = !searchedAccountStatus
    setIsChecked(!isChecked)
  
    console.log("Account Status is set to " + isChecked)
    if (!isChecked) {
      handleSetActiveUser()
    }else{
      handleSetInactiveUser()
    }
    
  } 

  const setAccountStatusInAPI = () => {
    console.log("(fetch) isChecked = " + isChecked)
    if (!sessionStorage.getItem('token')) {
      setAccountStatusError('User not logged in')
      return
    }
    const config = {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        token: sessionStorage.getItem('token')
      }
    }
    // if active or inactive
    fetch(isChecked ? `${api_host}/accounts/${searchedAccountID}/active` : `${api_host}/accounts/${searchedAccountID}/inactive` , config)
      .then(res => res.json())
      .then(data => {
        if (data && ((data.message && data.message.indexOf('Failed - Invalid Token') > -1) || (data.error && data.error.indexOf('Failed - Invalid SessionGUID') > -1))) {
          sessionStorage.removeItem('token')
          history.push('/signin')
        } else if (data && data.error && Array.isArray(data.error)) {
          setAccountStatusError(data.error.join('\n'))
        } else if (data && data.error && !Array.isArray(data.error)) {
          setAccountStatusError(data.error)
        } else if (data && data.description) {
          setAddEmailError(null)
          setDeleteEmailError(null)
          setUnlockUserError(null)
          //isChecked ? setAccountStatusError("Account set to active status") : setAccountStatusError("Account set to inactive status")
          //Success

        } else {
          setAccountStatusError('Something went wrong')
        }
      })
      .catch(() => setAccountStatusError('Something went wrong'))
  }
  const handleSetActiveUser = () => {
    if (!sessionStorage.getItem('token')) {
      setAccountStatusError('User not logged in')
      return
    }
    const config = {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        token: sessionStorage.getItem('token')
      }
    }
    // Active user API call
    fetch(`${api_host}/accounts/${searchedAccountID}/active`, config)
      .then(res => res.json())
      .then(data => {
        if (data && ((data.message && data.message.indexOf('Failed - Invalid Token') > -1) || (data.error && data.error.indexOf('Failed - Invalid SessionGUID') > -1))) {
          sessionStorage.removeItem('token')
          history.push('/signin')
        } else if (data && data.error && Array.isArray(data.error)) {
          setAccountStatusError(data.error.join('\n'))
        } else if (data && data.error && !Array.isArray(data.error)) {
          setAccountStatusError(data.error)
        } else if (data && data.description) {
          setAccountStatusError("Account set to active status")
          //Success
        } else {
          setAccountStatusError('Something went wrong')
        }
      })
      .catch(() => setAccountStatusError('Something went wrong'))
  }
  
  const handleSetInactiveUser = () => {
    if (!sessionStorage.getItem('token')) {
      setAccountStatusError('User not logged in')
      return
    }
    const config = {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        token: sessionStorage.getItem('token')
      }
    }
    // Inactive user API call
    fetch(`${api_host}/accounts/${searchedAccountID}/inactive`, config)
      .then(res => res.json())
      .then(data => {
        if (data && ((data.message && data.message.indexOf('Failed - Invalid Token') > -1) || (data.error && data.error.indexOf('Failed - Invalid SessionGUID') > -1))) {
          sessionStorage.removeItem('token')
          history.push('/signin')
        } else if (data && data.error && Array.isArray(data.error)) {
          setAccountStatusError(data.error.join('\n'))
        } else if (data && data.error && !Array.isArray(data.error)) {
          setAccountStatusError(data.error)
        } else if (data && data.description) {
          setAccountStatusError("Account set to Inactive status")
          //Success
        } else {
          setAccountStatusError('Something went wrong')
        }
      })
      .catch(() => setAccountStatusError('Something went wrong'))
  }


  return (
    <>
      {detailViewType === 'account' ? (
        <>
          <Navbar />
          <BreadcrumbSample
            goToHome={() => {
              setView('home')
            }}
            activePage="Account Details"
          />
          <div id="account-details">
          
            <button class='primary-btn unlock-user-btn' onClick={handleUnlockUser}>
              <div class="unlock-btn-label">Unlock Account</div></button>
            {unlockUserError && (<p className='error unlock-user-error'>{unlockUserError}</p>)}
            <div class="form-check account-status-box">
              <input 
                class="form-check-input" 
                type="checkbox" 
                value="" 
                id="account-status" 
                onChange={handleAccountStatus} 
                checked={isChecked}/>                        
              <label class="form-check-label" for="account-status">
                Active
              </label>
              {accountStatusError && (<p id="active-status"  className='error unlock-user-error'>{accountStatusError}</p>)}
            </div>
            <div id="account-id">
              <span>Account ID:</span>
              <span>{searchedAccountID}</span>
            </div>
            <div id="email-ids">
              <div className="email-id-label">
                <span>Email IDs:</span>
              </div>
              <div className="email-id-list-wrapper">
                {searchedAccountEmails &&
                  searchedAccountEmails.map((email, id) => (
                    <div key={id}>
                      <span className="email-span">{email}</span>
                      {searchedAccountEmails.length > 1 && (
                        <button
                          class="btn btn-outline-danger remove-button"
                          data-testid={email}
                          onClick={() => {
                            setMailToDelete(email)
                            setShowDeleletEmailModal(true)
                          }}
                        >
                          X
                        </button>
                      )}
                    </div>
                  ))}
                <ModalBS
                  show={showDeleletEmailModal}
                  handleClose={handleDelModalClose}
                  modalHeader={<>Warning!</>}
                  modalBody={
                    <p>Are you sure you want to remove this email ID?</p>
                  }
                  modalFooter={
                    <>
                      <button
                        className="primary-btn modal-btn"
                        onClick={handleDelModalClose}
                      >
                        No
                      </button>
                      <button
                        className="primary-btn modal-btn"
                        onClick={() => {
                          handleDelModalClose()
                          handleDeleteEmail(mailToDelete)
                        }}
                      >
                        Yes
                      </button>
                    </>
                  }
                ></ModalBS>
                {deleteEmailError && (
                  <p className="error">{deleteEmailError}</p>
                )}
              </div>
            </div>
            <div className="add-email-div">
              <p>Add Email ID</p>
              <input
                className="add-email-input"
                data-testid="add-account-id"
                type="add-account-id"
                name="add-account-id"
                id="add-account-id"
                onChange={handleAddEmailInput}
                ref={addEmailRef}
              />
              <button
                className="primary-btn add-email-btn"
                data-testid="add-email"
                onClick={handleAddEmail}
              >
                Add
              </button>
              {addEmailError && <p className="error">{addEmailError}</p>}
            </div>
            <hr />
            <UpdatePassword
              history={history}
              searchedAccountID={searchedAccountID}
            />
            <a
              href=""
              onClick={e => {
                e.preventDefault()
                setDetailViewType('currentMail')
              }}
            >
              View Current Emails in mailbox
            </a>
            <a
              className="msg-history-link"
              href=""
              onClick={e => {
                e.preventDefault()
                setDetailViewType('messageHistory')
              }}
            >
              View message history
            </a>
          </div>
        </>
      ) : (
        <>
          {detailViewType === 'currentMail' ? (
            <>
              <CurrentMail
                setView={setView}
                setDetailViewType={setDetailViewType}
                searchedAccountID={searchedAccountID}
                history={history}
              />
            </>
          ) : (
            <>
              <MessageHistory
                setView={setView}
                setDetailViewType={setDetailViewType}
                searchedAccountID={searchedAccountID}
                history={history}
              />
            </>
          )}
        </>
      )}
    </>
  )
}

export default DetailView
